import Vue from 'vue';

const prettyBytes = require('pretty-bytes');

Vue.filter('fileSize', function(value) {
  return prettyBytes(parseFloat(value));
});
